export default __webpack_public_path__ + "static/images/plugin-smtp.png?a51cb0ab6287ad279f6817f522c88f0f";